import * as React from 'react';
const {
  useState
} = React;
const noop = () => {};
export const useHover = function (element) {
  let mouseEnterDelayMS = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  const [state, setState] = useState(false);
  let mouseEnterTimer;
  const onMouseEnter = originalOnMouseEnter => event => {
    (originalOnMouseEnter || noop)(event);
    mouseEnterTimer = window.setTimeout(() => setState(true), mouseEnterDelayMS);
  };
  const onMouseLeave = originalOnMouseLeave => event => {
    (originalOnMouseLeave || noop)(event);
    window.clearTimeout(mouseEnterTimer);
    setState(false);
  };
  if (typeof element === 'function') {
    element = element(state);
  }
  const el = /*#__PURE__*/React.cloneElement(element, {
    onMouseEnter: onMouseEnter(element.props.onMouseEnter),
    onMouseLeave: onMouseLeave(element.props.onMouseLeave)
  });
  return [el, state];
};
export default useHover;